<template>
  <!-- class="demo-inline-spacing ml-1 mb-1" -->
  <b-col
    sm="12"
    md="6"
    class="mb-1"
  >
    <!-- lg="6"
    xl="4" -->
    <b-row>
      <b-col cols="2">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          :variant="url ? variantColor(viewDoc) : 'danger'"
          :disabled="!url"
          class="mr-75 btn-icon"
          @click="showDocument"
        >
          <feather-icon icon="FileTextIcon" />
        </b-button>
      </b-col>
      <b-col cols="10">
        <div class="user-page-info">
          <h6 class="mb-0">
            {{ name }}
          </h6>
          <small>{{ uploadName(url, required) }}</small>
        </div>
      </b-col>
    </b-row>
  </b-col>
  <!-- </div> -->
</template>

<script>
import {
  BButton, BCol, BRow,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

import PrebecarioService from '@/services/PrebecariosService'

export default {
  directives: { Ripple },
  components: {
    BButton,
    BCol,
    BRow,
  },
  props: {
    id: {
      type: Number,
      default: () => {},
    },
    name: {
      type: String,
      default: () => {},
    },
    url: {
      type: String,
      default: () => {},
    },
    required: {
      type: Boolean,
      required: true,
    },
    ok: {
      type: Boolean,
      default: () => {},
    },
    isDisabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isOK: () => {},
      viewDoc: false,
    }
  },
  computed: {
    variantColor() {
      const color = { false: 'primary', true: 'warning' }
      return status => color[status]
    },
    uploadName() {
      return (url, required) => {
        if (url) {
          const array = url.split('/')
          const n = array.length
          return array[n - 1]
        }
        const text = (required) ? '(requerido)' : '(No requerido)'
        return `Sin Documento ${text}`
      }
    },
  },
  mounted() {
    this.isOK = this.ok
  },
  methods: {
    showDocument() {
      this.viewDoc = true
      window.open(this.url, '_blank', 'width=600,height=800')
    },
    updateChekedDocument(checked) {
      PrebecarioService.updateDocumentValid(this.id, {
        validado: checked,
      })
        .then(response => {
          if (response.status === 200) {
            this.isOK = response.data.validado
            this.$emit('update', {
              id: this.id,
              value: this.isOK,
            })
          }
        })
    },
  },
}
</script>

<style></style>
